import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { STREAK_STEP } from '@/helpers/constants';
import { ProgressCircle } from './progress';
import s from './index.module.scss';

export const MilestoneCard = ({ currentStreak = 0, reward }) => {
  const { t } = useTranslation('streak');
  const segmentStart = reward.milestone - 3;
  const isLocked = currentStreak < segmentStart;

  const percentage = useMemo(() => {
    if (currentStreak >= reward.milestone) return 100;
    if (currentStreak < segmentStart) return 0;
    return ((currentStreak % STREAK_STEP) / STREAK_STEP) * 100;
  }, [currentStreak]);

  const isCompleted = percentage >= 100;

  const stateLabel = useMemo(() => {
    if (isLocked) return t('milestone_card.complete_previous_milestone');
    if (isCompleted) return t('milestone_card.completed');
    if (currentStreak === 0)
      return t('milestone_card.make_your_first_investment');
    if (currentStreak % STREAK_STEP) return t('milestone_card.in_progress');
    return t('milestone_card.make_your_next_investment');
  }, [currentStreak, isLocked, isCompleted]);

  return (
    <div className={s.card}>
      <div className={s.top}>
        <ProgressCircle
          isLocked={isLocked}
          isCompleted={isCompleted}
          percentage={percentage}
        />
        <div className={s.info}>
          <div className="f-body-accent">
            {t('milestone_card.invest_in_straight_rounds', {
              milestone: reward.milestone,
            })}
          </div>
          <div className="f-small-regular" style={{ color: '#52626F' }}>
            {stateLabel}
          </div>
        </div>
      </div>
      <div className={s.bottom}>
        <div>
          <div className="f-paragraph-accent">
            +{reward.income_increase.toFixed(2)}%
          </div>
          <div className="f-small-regular" style={{ color: '#52626F' }}>
            {t('milestone_card.income_increase')}
          </div>
        </div>
        <div>
          <div className="f-paragraph-accent">
            {reward.net_cash_flow_bonus.toFixed(2)}%
          </div>
          <div className="f-small-regular" style={{ color: '#52626F' }}>
            {t('milestone_card.net_cash_flow_bonus')}
          </div>
        </div>
      </div>
    </div>
  );
};
